export default __webpack_public_path__ + "static/k8s-icon-5dc2bed9013be71d5b30e5c2774697ef.svg";